import React from "react";
import PhoneMockup from "./PhoneMockup";
import AppStoreBadge from "./AppStoreBadge";
import { brand, hero } from "../mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-velis-dark">
      {/* Mountain sunset background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${hero.background})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-[#0b0b0d]" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-10 pt-24 pb-16 min-[900px]:pt-28 min-[900px]:pb-20 grid min-[900px]:grid-cols-2 gap-10 items-center">
        <div className="text-center min-[900px]:text-left">
          <span className="velis-wordmark text-white text-2xl block mb-5">{brand.name}</span>
          <h1 className="font-display font-extrabold text-white leading-[1.05] text-4xl sm:text-5xl min-[900px]:text-[3.1rem]">
            {hero.title}
            <br />
            <span className="text-velis-orange">{hero.titleAccent}</span>
          </h1>
          <p className="mt-6 text-white/75 text-lg max-w-lg mx-auto min-[900px]:mx-0 leading-relaxed">
            {hero.subtitle}
          </p>

          <div className="mt-8 flex justify-center min-[900px]:justify-start">
            <AppStoreBadge />
          </div>
        </div>

        <div className="flex justify-center min-[900px]:justify-end">
          <PhoneMockup src={hero.image} alt="Écran d’accueil VÉLIS" width={215} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
